import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

// application
import { ArrowRoundedRight6x9Svg } from '../../svg';
import { getData } from '../../services/fetch-service';

function PageBreadcrumbs(props) {
    const { shfaqbreadcrumb } = props;
    const url = window.location.pathname.split('/').pop();
    const { locale } = props;
    const params = useParams();
    const [breadcrumb, setBreadcrumbs] = useState([]);
    useEffect(() => {
        getData(`Home/GetMenuPath?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            setBreadcrumbs(response.data);
        });
    }, [url]);

    let showbreadcrumbs;

    const homeBreadcrumb = (
        <li className="breadcrumb-item">
            <Link to="/"><FormattedMessage id="MobileMenu.Home" defaultMessage="Ballina" /></Link>
            <ArrowRoundedRight6x9Svg className="breadcrumb-arrow" />
        </li>
    );
    if (breadcrumb.length > 0) {
        const lastIndex = breadcrumb.length - 1;
        const breadcrumbs = breadcrumb.map((item, index) => {
            let link;
            if (lastIndex === index) {
                link = <li key={index} className="breadcrumb-item active" aria-current="page">{item.pageName}</li>;
            } else {
                link = (
                    <li key={index} className="breadcrumb-item">
                        <Link to={item.url}>{item.pageName}</Link>
                        <ArrowRoundedRight6x9Svg className="breadcrumb-arrow" />
                    </li>
                );
            }
            return link;
        });
        if (shfaqbreadcrumb !== false) {
            showbreadcrumbs = (
                <div className="page-header__breadcrumb">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {homeBreadcrumb}
                            {breadcrumbs}
                        </ol>
                    </nav>
                </div>
            );
        }
    }

    return (
        <div className="page-header">
            <div className="page-header__container full-margin">
                {shfaqbreadcrumb !== false ? showbreadcrumbs : ''}
                {/* {header} */}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageBreadcrumbs);
